import { type ReactNode } from 'react'
import { Button } from '@/components/Button'
import { Form } from '@/components/Form'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentDescription,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetSection,
} from '@/components/ModalSheet'
import { AnimatedIcon } from '@/components/AnimatedIcon'
import styles from './JoinWorkspaceAsAdminDialog.module.css'

export interface JoinWorkspaceAsAdminDialogProps {
  showing: boolean
  onClose: () => void
  onSubmit: () => void
  isSubmitPending: boolean
  /**
   * The form fields.
   */
  children: ReactNode
}

export function JoinWorkspaceAsAdminDialog({
  showing,
  onClose,
  onSubmit,
  isSubmitPending,
  children,
}: JoinWorkspaceAsAdminDialogProps) {
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={isSubmitPending ? undefined : onClose}
      disableCloseOnOutsideClick
    >
      <ModalSheetHeader withCloseButton />

      <ModalSheetContent>
        <ModalSheetSection horizontallySpaced>
          <ModalSheetContentTitle>
            <span className={styles.titleRow}>
              <AnimatedIcon name="stars" size={28} />
              Join Workspace
              <AnimatedIcon name="stars" size={28} />
            </span>
          </ModalSheetContentTitle>
          <ModalSheetContentDescription compact>
            Select a workspace to join as an admin.
          </ModalSheetContentDescription>
        </ModalSheetSection>

        <ModalSheetSection spaced>
          <Form id="joinWorkspaceAsAdmin" onSubmit={onSubmit}>
            {children}
          </Form>
        </ModalSheetSection>
      </ModalSheetContent>

      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Cancel"
            variant="default"
            onPress={onClose}
            isDisabled={isSubmitPending}
          />
          <Button
            label={isSubmitPending ? 'Joining...' : 'Join Workspace'}
            type="submit"
            form="joinWorkspaceAsAdmin"
            variant="primary"
            isDisabled={isSubmitPending}
            testId="join-workspace-as-admin-submit"
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
